import Ajv from 'ajv/dist/2020';
import addFormats from 'ajv-formats';
import schema from './protocol.generated.json';
import type { components } from './api.generated';

export type Snapshot = components['schemas']['Snapshot'];
export type PoseCommand = components['schemas']['PoseRequest'];
export type Connection = components['schemas']['ConnectionResponse'];
export type WorldManifest = components['schemas']['World'];
export type Pong = components['schemas']['Pong'];
export type ChatResult = components['schemas']['ChatResult'];
export type SpeechDelivery = components['schemas']['SpeechDelivery'];
export type MuteResult = components['schemas']['MuteResult'];

const ajv = new Ajv({ strict: true, allErrors: true });
addFormats(ajv);
ajv.addSchema(schema);
export const isSnapshot = ajv.compile<Snapshot>({ $ref: 'city-protocol#/$defs/Snapshot' });
export const isPong = ajv.compile<Pong>({ $ref: 'city-protocol#/$defs/Pong' });
export const isChatResult = ajv.compile<ChatResult>({ $ref: 'city-protocol#/$defs/ChatResult' });
export const isSpeechDelivery = ajv.compile<SpeechDelivery>({
  $ref: 'city-protocol#/$defs/SpeechDelivery',
});
export const isMuteResult = ajv.compile<MuteResult>({ $ref: 'city-protocol#/$defs/MuteResult' });
export const isEmoteResult = ajv.compile<components['schemas']['EmoteResult']>({
  $ref: 'city-protocol#/$defs/EmoteResult',
});
export const isConnection = ajv.compile<Connection>({
  $ref: 'city-protocol#/$defs/ConnectionResponse',
});
export const isManifest = ajv.compile<WorldManifest>({ $ref: 'city-protocol#/$defs/World' });
